import { object, string } from "yup"
import { PORT_REGEX } from "@/utils/regex"

export default object({
  ip: string().required().trim(),
  port: string().required().matches(PORT_REGEX),
  username: string().required(),
  password: string().required(),
  region: string().required(),
})
